import { toast } from "@/components/toast/toast-queue";

export const errorToast: (error: Error) => void = (error: Error) => {
  toast.add(
    {
      title: error.message,
      type: "error",
    },
    {
      timeout: 5000,
    },
  );
};

export const successToast: () => void = () => {
  toast.add(
    {
      title: "User created",
      type: "success",
    },
    {
      timeout: 5000,
    },
  );
};
